import React from "react";
import "./styles";
import { LockedIconContainer } from "./styles";
import { ReactComponent as InfoSvg } from "../../assets/newImages/icons/lock.svg";
import { useTheme } from "../../contexts/Theme/ThemeContext";
import { Link } from "react-router-dom";

interface LockedIconProps {
  mensagem?: string;
  width?: string;
  style?: React.CSSProperties;
  className?: string;
  redirect?: boolean;
}

const LockedIcon: React.FC<LockedIconProps> = ({
  width = "2.4rem",
  mensagem = "",
  style,
  className,
  redirect = true,
}) => {
  const { theme } = useTheme();

  return redirect ? (
    <Link to="/perfil/usuarios/planos" style={{ textDecoration: "none" }}>
      <LockedIconContainer
        theme={theme}
        width={width}
        mensagem={mensagem}
        showPopover={!!mensagem}
        style={style}
        className={className}
      >
        <InfoSvg />
      </LockedIconContainer>
    </Link>
  ) : (
    <LockedIconContainer
      theme={theme}
      width={width}
      mensagem={mensagem}
      showPopover={!!mensagem}
      style={style}
      className={className}
    >
      <InfoSvg />
    </LockedIconContainer>
  );
};

export default LockedIcon;
